/**
 * Single source of truth for email-type flow touchpoints / action types.
 *
 * The visual flow builder used to offer many separate email touchpoints
 * (Cold Email, Follow Up Email, Nurture Email, ...). These have been reduced
 * to just "Send Email" (email_sent) and "Send Newsletter" (newsletter).
 *
 * The legacy types are kept here so already-saved flows keep rendering and are
 * still recognised as email steps at runtime — they are simply no longer
 * offered as new options in the builder palette.
 */

// Currently offered in the flow builder palette.
export const ACTIVE_EMAIL_ACTION_TYPES = ['email_sent', 'newsletter'];

// Legacy email action types kept for backwards compatibility only.
export const LEGACY_EMAIL_ACTION_TYPES = [
  'cold_email',
  'follow_up_email',
  'nurture_email',
  'case_study_email',
  'testimonial_email',
  'reminder_email',
];

// Everything that counts as an "email step" at runtime.
export const EMAIL_ACTION_TYPES = [
  ...ACTIVE_EMAIL_ACTION_TYPES,
  ...LEGACY_EMAIL_ACTION_TYPES,
];

/**
 * True when the given action type represents any kind of email touchpoint.
 */
export const isEmailActionType = (type) => EMAIL_ACTION_TYPES.includes(type);

const flowTouchpoints = {
  ACTIVE_EMAIL_ACTION_TYPES,
  LEGACY_EMAIL_ACTION_TYPES,
  EMAIL_ACTION_TYPES,
  isEmailActionType,
};

export default flowTouchpoints;
